import { CompareFn } from '@epicuro-next/models/sorting';
import { compareNumbers, compareStrings } from '@epicuro-next/utilities';
import {
  BasketColumnKeys,
  BasketGroupSortType,
  BasketRowsGroup,
} from 'graphql-api/baskets-api-interfaces';

import { getLineColumnValues } from '../shared';

/**
 * Default comparing method uses alphabetical order on group title.
 */
export const alphabeticalFunction = compareStrings<BasketRowsGroup>(
  (x) => x.title || '',
);

/**
 * Comparers configuration. Only aggregated values for groups.
 */
export const groupComparers: {
  [key in BasketGroupSortType]?: CompareFn<BasketRowsGroup>;
} = Object.freeze({
  [BasketGroupSortType.TotalNet]: compareNumbers(
    (x) => getLineColumnValues(x, BasketColumnKeys.ValueNet) ?? 0,
  ),
  [BasketGroupSortType.TotalWsp]: compareNumbers(
    (x) => getLineColumnValues(x, BasketColumnKeys.Value) ?? 0,
  ),
  [BasketGroupSortType.TotalRrp]: compareNumbers(
    (x) => getLineColumnValues(x, BasketColumnKeys.ValueRrp) ?? 0,
  ),
  [BasketGroupSortType.Quantity]: compareNumbers(
    (x) => getLineColumnValues(x, BasketColumnKeys.Quantity) ?? 0,
  ),
  [BasketGroupSortType.Alphabetical]: alphabeticalFunction,
  [BasketGroupSortType.CreatedDate]: compareStrings((x) => x.created || ''),
});
